import { LinearProgress, List, ListItem, ListItemText } from "@mui/material";

import { TrackingFile } from "@/hooks/files/useFileUploadState";

export function FileProgress({ files }: { files: TrackingFile[] }) {
  return (
    <List>
      {files.map(({ trackingId, progress, file }) => (
        <ListItem sx={{ px: 0, py: 0.15 }} key={trackingId}>
          <ListItemText
            primary={file.name}
            secondary={<LinearProgress color="primary" variant="determinate" value={progress} />}
            primaryTypographyProps={{ mb: 0.25, color: "text.secondary" }}
            secondaryTypographyProps={{ component: "div" }}
          />
        </ListItem>
      ))}
    </List>
  );
}
